import React, {FC, useState} from "react";
import { Input as LegacyInput } from "@jane/lib/src/components/form/Input";
import { useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {TeamSpaceTemplate} from "../../../lib/src/api/repositories/documentation-library-repository";
import {Input } from "@ventumsoftware/react-toolkit"

export const EditTeamSpaceTemplateModal: FC<{template: TeamSpaceTemplate, onFinish: () => void}> = (props) => {
  const {documentations} = useApiCall(config)
  const [name, setName] = useState(props.template.name)
  const [content, setContent] = useState(props.template.content ?? '')
  const {showToast} = useToasts()
  const submit = async () => {
    await documentations.updateTemplate(props.template.id, name, content).then(() => {
      showToast('Aangemaakt', 'Sjabloon aangemaakt')
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het aanmaken van het sjabloon')
    })
  }

  return <div className={"flex flex-col space-y-3"}>
    <LegacyInput type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Input type={'rtf'} label={'Inhoud'} value={content} onChange={setContent} />
    <ModalFooter text={'Wijzigingen opslaan'} isDisabled={name.length < 3} onSubmit={async () => {
      await submit()
      close()
      props.onFinish()
    }} />
  </div>
}
